var zh = {
	'选单':'选单',
	'菜单':'菜单',
	'搜索':'搜索',
	'关闭':'关闭',
	'没有结果，请输入其他关键字':'没有结果，请输入其他关键字',
	'手表系列':'手表系列',
	'新闻模块':'新闻模块',
	'防伪检测':'防伪检测',
	'关注':'关注',
	'成为我们的一员':'成为我们的一员',
	'打开微信扫一扫':'打开微信扫一扫',
	'关于品牌':'关于品牌',
	'全部手表':'全部手表',
	'探索':'探索',
	'巴博斯腕表':'巴博斯腕表',
	'品牌与帆船运动界的深厚渊源，最早可追溯至1950年代。启发自此悠久传统，游艇名仕型腕表集实用功能与非凡风格于一身，而游艇名仕型 II计时腕表则为劳力士超卓技术结晶，专为帆船赛计时而设计。':'品牌与帆船运动界的深厚渊源，最早可追溯至1950年代。启发自此悠久传统，游艇名仕型腕表集实用功能与非凡风格于一身，而游艇名仕型 II计时腕表则为劳力士超卓技术结晶，专为帆船赛计时而设计。',
	'防伪监测文案':'防伪监测文案',
	'游艇名仕型结合非凡风格与性能，从容应对海中或船上的各种场合。凭借其防水和坚固特质，成为水上运动以至扬帆出海的腕表之选。':'游艇名仕型结合非凡风格与性能，从容应对海中或船上的各种场合。凭借其防水和坚固特质，成为水上运动以至扬帆出海的腕表之选。',
	'甄别自己':'甄别自己',
	'联系我们':'联系我们',
	'查看新闻':'查看新闻',
	'探寻附近门店':'探寻附近门店',
	'品牌新闻':'品牌新闻',
	'全部':'全部',
	'防伪检测查询':'防伪检测查询',
	'输入防伪码':'输入防伪码',
	'输入20位纯数字校验':'输入20位纯数字校验',
	'查询':'查询',
	'商品不正确':'商品不正确',
	'商品为正版':'商品为正版',
	'重新检测':'重新检测',
	'联系电话':'联系电话',
	'联系邮箱':'联系邮箱',
	'探索尊贵非凡且精准可靠的巴博斯腕表':'探索尊贵非凡且精准可靠的巴博斯腕表',
	'一系列图集':"一系列图集",
	'技术规格':'技术规格',
	'其他推荐':'其他推荐',
	'巴博斯腕表精品店':'巴博斯腕表精品店',
	'凭借丰富经验及专业知识，竭诚助您选购可伴随一生的时计。':'凭借丰富经验及专业知识，竭诚助您选购可伴随一生的时计。',
	'备注文案、欢迎语等。':'备注文案、欢迎语等。',
	'暂无数据':'暂无数据',
	'请输入关键字':'请输入关键字',
	'服务中心':'服务中心',
	'使用条款':'使用条款',
	'隐私协议':'隐私协议',
	'新闻详情':'新闻详情',
	'当前为该语言无需切换':'当前为该语言无需切换',
	'上一条':'上一条',
	'查看更多':'查看更多',
	'下一条':'下一条',
	'已经是第一篇了':'已经是第一篇了',
	'没有下一篇了':'没有下一篇了',
	'巴博斯精品推荐':'巴博斯精品推荐',
	'型号':'型号',
	'欢迎来到JINLERY巴博斯腕表店':'欢迎来到JINLERY巴博斯腕表店',
	'专业设计、科技创新、力求上进':'专业设计、科技创新、力求上进',
	'首页':'首页',
	'切换语言': '切换语言',
	'搜索巴博斯网站': '搜索巴博斯网站',
	'品牌探索': '品牌探索',
	'使用与服务': '使用与服务',
	'服务政策': '服务政策',
	'腕表展廊': '腕表展廊',
	'查询不存在，请核实防伪码': '查询不存在，请核实防伪码',
	'系列图片': '系列图片',
	'更多图片': '更多图片',
	'更多视频': '更多视频',
	'详情图片': '详情图片',
	'腕表系列': '腕表系列',
	'真伪查询服务': '真伪查询服务',
	'常见问题': '常见问题',
	'服务条款': '服务条款',
	'隐私政策': '隐私政策',
	'输入20位数的纯数字检查': '输入20位数的纯数字检查',
	'返回首页': '返回首页',
	'返回': '返回',
	'关注巴博斯': '关注巴博斯',
	'成为我们的一员': '成为我们的一员',
	'打开微信并扫码': '打开微信并扫码',
	'上一页': '上一页',
	'下一页': '下一页',
	'您好，您所查询的是由巴博斯品牌生产的德国手表，该产品经验证为正品。':'您好，您所查询的是由巴博斯品牌生产的德国手表，该产品经验证为正品。',
	'了解更多款式':'了解更多款式'
}
export default zh